import Cookies from 'js-cookie'

const app_id = 'onewarehouse'

export const SLQ_ENV_MAP: Record<string, 'DEV' | 'TEST' | 'FAT' | 'PRO'> = {
  /* dev 环境没有数据展示, 所以这里开发环境直接使用 测试环境配置 */
  develop: 'TEST',
  test: 'TEST',
  preview: 'FAT',
  product: 'PRO',
}

export const slTraceInit = () => {
  const uid = Cookies.get('osudb_uid')

  window?.slq('init', {
    options: {
      debugMode: process.env.NODE_ENV === 'development',
    },
    params: {
      app_id, // 应用id
      user_id: uid, // 用户id
      env: SLQ_ENV_MAP[process.env.APP_ENV],
    },
  })
}
